import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormBuilder, FormArray } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { AccountsCreateComponent } from '../../accounts-create.component';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'tab-history',
  templateUrl: './tab-history.component.html',
  styleUrls: ['./tab-history.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class TabHistoryComponent implements OnInit {
  form: FormGroup;
  id: string;
  /**
   * Constructor
   * 
   * @param {FormBuilder} _formBuilder
   */
  custom2Settings: FormArray;
  viewRecord: boolean;
  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private _accountsCreateComponent: AccountsCreateComponent
  ) {
    this.form = this._accountsCreateComponent.form;
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.parent.paramMap.get('id');
  }

}
